import { CalcState, CalcStatus } from "@/models/Models";
import { PriorityICSetting } from "@/services/index.defs";

export function sortCalcsByPriority(calcsList: CalcState[], prioritySettingsList: readonly PriorityICSetting[]) {
    const sortedList = calcsList
        .sort((a, b) => b.status - a.status).filter((el) => el);

    if (!prioritySettingsList?.length)
        return sortedList;

    const reorderedCalcs = [];
    prioritySettingsList.forEach((el) => {
        const calcIdx = sortedList.findIndex((calc) => calc.insuranceProviderId === el?.name);
        if (calcIdx === -1 || sortedList[calcIdx].status === CalcStatus.Processing)
            return;

        const calcSec = el?.seq;
        if (!Number.isFinite(calcSec) || calcSec <= 0)
            return;

        let newCalcIdx = calcSec - 1;

        if (newCalcIdx >= prioritySettingsList.length)
            newCalcIdx = prioritySettingsList.length - 1;

        if (newCalcIdx >= sortedList.length)
            newCalcIdx = sortedList.length - 1;

        if (newCalcIdx === calcIdx)
            return;

        const [reorderedCalc] = sortedList.splice(calcIdx, 1);

        const foundEqualReorderItem = reorderedCalcs.find((reordered) => reordered.newIdx === newCalcIdx);
        if (foundEqualReorderItem) {
            const equalItemSeq = foundEqualReorderItem.seq;
            if (equalItemSeq < calcSec)
                newCalcIdx++;
            else if (equalItemSeq > calcSec)
                newCalcIdx--;
        }

        reorderedCalcs.push({ name: el?.name, seq: el?.seq, newIdx: newCalcIdx });

        sortedList.splice(newCalcIdx, 0, reorderedCalc);
    });

    return sortedList;
};
